import { configureStore } from "@reduxjs/toolkit";

import categories from "../reducers/categories";
import products from "../reducers/products";
import general from "../reducers/general";

export const store = configureStore({
  reducer: {
    categories,
    products,
    general,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
